class CheckoutConfirmationOrderSaveToListController {
    constructor($sce, settings, orderManagementService, analyticsService, savedListsService) {
        this.$sce = $sce;
        this.settings = settings;
        this.orderManagementService = orderManagementService;
        this.analyticsService = analyticsService;
        this.savedListsService = savedListsService;
    }

    $onInit() {
        this.showListLink = false;
        this.showErrorMessage = false;
        this.listId = '';
        this.responseMessage = '';
        this.loading = false;
    }

    saveAsListClick() {
        this.loading = true;
        return this.orderManagementService.saveOrderToList(this.orderId).then((response) => {
            if (response.Success) {
                this.listId = response.ListId;
                this.showListLink = true;
                this.responseMessage = `Saved to Lists as '${response.ListName}' `;
                this.savedListsService.invalidateCache();

                this.savedListsService.getProductsForSelectedList(this.listId).then((list) => {
                    list.ListId = this.listId;
                    list.Name = response.ListName;
                    list.ProductsCount = list.TotalRecordCount;
                    list.Timestamp = Date.now();
                    this.analyticsService.push({
                        data: {
                            trackingType: 'link',
                            list,
                            product: list.Items,
                        },
                        type: this.analyticsService.mapperTypes.customEvent.list.AddOrder,
                    });

                    this.loading = false;
                });
            } else {
                this.showErrorMessage = true;
                console.warn(`Save order to list error: ${response.Message}`);
            }

        });
    }
}

CheckoutConfirmationOrderSaveToListController.$inject = ['$sce', 'Settings', 'OrderManagementService', 'AnalyticsService', 'SavedListsService'];

const checkoutConfirmationOrderSaveToListControllerComponentDefinition = {
    bindings: {
        orderId: '<',
    },
    controller: CheckoutConfirmationOrderSaveToListController,
    template: require('./checkout-confirmation-order-save-to-list.component.html').trim(),
};

module.exports = {
    CheckoutConfirmationOrderSaveToListController,
    checkoutConfirmationOrderSaveToListControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/order/confirmation/checkout-confirmation-order-save-to-list.component.js